export enum SigninTrackEventName {
  Started = 'Login Started',
  FieldCompleted = 'Login Field Completed',
  Initiated = 'Login Initiated',
  ModalClosed = 'Login Modal Closed',
  ForgotPasswordTapped = 'Forgot Password Tapped',
  Failed = 'Login Failed',
  Succeeded = 'Login Succeeded',
  Abandoned = 'Login Abandoned',
  GuestSelected = 'Continue As Guest Selected',
}

export type SigninIdentifierType = 'email' | 'member_number';

export type SigninErrorType = 'invalid_credentials' | 'account_locked' | 'network';
